<template>
  <div>
    <Top />
    <div class="maindiv pproject-wrap  bg-gray">
      <Banner />
      <div class="mt25 bgw htmldiv">
        <banner-title :tname="'打印'" :t_tile="'特种工培训'"/>
        <div class="ncont detail">
          <div class="sign-row center-row">

            <!-- <router-link class="sub-button" v-if="this.info.save!=1" :to="'/train/project/sign-up-tz?id='+this.info.train_id+'&cid='+this.info.cid">修改</router-link> -->
            <a class="sub-button" href="javascript:;" @click="flow=1">申请表</a>
            <a class="sub-button" href="javascript:;" @click="flow=2">健康表</a>
            <a class="sub-button" href="javascript:;" @click="print">打印</a>
            <a class="sub-button" href="javascript:;" @click="dowmLoadPdf">下载</a>
          </div>
        </div>
        <div v-if="flow==1" ref="print" id="pdfDom" style="font-family:SimSun; width: 1080px;height:auto;text-align: center;font-size: 24px;" class="print-div">
          <label style="font-family: 'Microsoft YaHei';font-size: 36px;font-weight: bold;margin: 0 0 20px 0;display: inline-block;color: #000;">浙江省特种作业操作证申请表</label>
          <table style="margin: 0 auto;width: 1000px;border: 3px solid #000;border-collapse: collapse;font-size: 24px;table-layout: fixed;">
            <colgroup>
                <col style="width: 8.9%" span="2"></col>
                <col style="width: 6.1%" span="2"></col>
                <col style="width: 8.9%" span="2"></col>
                <col style="width: 5%" span="2"></col>
                <col style="width: 11.3%" span="2"></col>
                <col style="width: 8.9%" span="2"></col>
            </colgroup>
            <tr style="height: 70px;">
              <td style="border: 1px solid #000;" colspan="2">姓　　名</td>
              <td style="border: 1px solid #000;" colspan="2">{{info.name}}</td>
              <td style="border: 1px solid #000;">性 别</td>
              <td style="border: 1px solid #000;">{{gender_list[info.gender]}}</td>
              <td style="border: 1px solid #000;" colspan="2">出生年月</td>
              <td style="border: 1px solid #000;" colspan="2">{{info.birthday}}</td>
              <td style="border: 1px solid #000;;" colspan="2" rowspan="3">贴<br/>照<br/>片</td>
            </tr>
            <tr style="height: 70px;">
              <td style="border: 1px solid #000;" colspan="2">身份证号码</td>
              <td style="border: 1px solid #000;" colspan="8">{{info.cid}}</td>
            </tr>
            <tr style="height: 70px;">
              <td style="border: 1px solid #000;font-size: 20px;" colspan="2">工作单位<br/>（发票抬头）</td>
              <td style="border: 1px solid #000;font-size: 20px;" 
              :colspan="info.specialWorkerTraining.type != 22 && !info.education  ? 8 : 4">{{info.company}}</td>
              <template v-if="info.specialWorkerTraining.type == 2">
                <td style="border: 1px solid #000;">初领证日期</td>
                <td style="border: 1px solid #000;" colspan="3">{{info.issue_date}}</td>
              </template>
              <template v-else-if="info.education">
                <td colspan="2" style="border: 1px solid #000;">学 历</td>
                <td colspan="2" style="border: 1px solid #000;" >
                  {{edu_options[info.education]}}
                </td>
              </template>
            </tr>
            <tr style="height: 70px;">
              <td style="border: 1px solid #000;font-size: 20px;" colspan="2">通讯地址<br/>（证件邮寄地址）</td>
              <td style="border: 1px solid #000;font-size: 20px;" colspan="4" >{{info.address}}</td>
              <td colspan="2" style="border: 1px solid #000;">手 机<br/>号 码</td>
              <td style="border: 1px solid #000;" colspan="4">{{info.phone}}</td>
            </tr>
            <tr style="height: 70px;">
              <td style="border: 1px solid #000;" colspan="2">申请作业<br/>类　　别</td>
              <td style="border: 1px solid #000;color: #000;font-weight: bold;" colspan="4">{{info.train_project}}</td>
              <td colspan="2" style="border: 1px solid #000;">准 操<br/>项 目</td>
              <td style="border: 1px solid #000;;color: #000;font-weight: bold;" colspan="4">{{info.train_type}}</td>
            </tr>
            <tr style="line-height: 28px;">
              <td style="border: 1px solid #000;" colspan="2">个人承诺</td>
              <td style="border: 1px solid #000;text-align: left;padding-top: 10px;padding-left: 10px;font-size: 20px;" colspan="10">　　本人身体健康，并无妨碍从事相应特种作业 器质性心脏病、癫痫病、美尼尔氏症、昡晕症、癔病、震颤麻痹症、精神病、痴呆症以及其他疾病和生理缺陷。填写的个人信息和报名材料内容真实。<br />
                　　本人对以上信息的真实性负责，如有隐瞒，相关责任全部由本人承担。<br />
                <div style="margin-bottom: 20px;">
                  <span style="float: left;">
                  <span style="display: inline-block;margin-top: 30px">（本人签字）：</span>
                  <img class="signature" v-if="info.electronic_signature" :src="info.electronic_signature" /></span>
                  <span style="float: right;margin-top: 30px;margin-right: 30px;">{{info.year}} 年 {{info.month}} 月 {{info.day}} 日</span>
                  <div style="clear:both; height: 0; line-height: 0; font-size: 0"></div>
                </div>
                　　根据《特种作业人员安全技术培训考核管理规定》：特种作业操作资格考试包括安全技术理论考试和实际操作考试两部分。考试不及格的，允许补考１次。首次补考不及格的，可再参加一轮考试，经补考，仍不及格的，重新参加相应的安全技术培训。
                <div style="margin-bottom: 20px;">
                  <span style="float: left;"><span style="display: inline-block;margin-top: 30px">（本人签字）：</span><img class="signature" v-if="info.electronic_signature" :src="info.electronic_signature" /></span>
                  <span style="float: right;margin-top: 30px;margin-right: 30px;">{{info.year}} 年 {{info.month}} 月 {{info.day}} 日</span>
                  <div style="clear:both; height: 0; line-height: 0; font-size: 0"></div>
                </div>
              </td>
            </tr>
            <tr style="line-height: 30px;height: 260px;overflow: hidden;">
              <td style="border: 1px solid #000;" colspan="12">
                <img :src="info.cid_photos" style="max-width:45%;height: 240px;margin-left: 10px;"/>
                <img :src="info.cid_photos_back" style="max-width:45%;height: 240px;margin-left: 10px;"/>
              </td>
            </tr>
            <tr style="line-height: 30px;">
              <td style="border: 1px solid #000;" colspan="2">培训机构<br/>意　　见</td>
              <td style="border: 1px solid #000;text-align: left;padding-top: 10px;padding-left: 10px;" colspan="10">
                <div style="text-align: right;margin-top: 40px;margin-bottom: 10px;margin-right: 50px;">
                  <div> （盖章）</div>
                  <div  style="margin-top: 5px;">年&nbsp;月&nbsp;日 </div>
                </div>
              </td>
            </tr>
            <tr style="line-height: 30px;">
              <td style="border: 1px solid #000;" colspan="2">考核部门<br/>意　　见</td>
              <td style="border: 1px solid #000;text-align: left;padding-top: 10px;padding-left: 10px;" colspan="10">
                <div style="text-align: right;margin-top: 40px;margin-bottom: 10px;margin-right: 50px;">
                  <div> （盖章）</div>
                  <div style="margin-top: 5px;">年&nbsp;月&nbsp;日 </div>
                </div>
              </td>
            </tr>
            <tr style="line-height: 30px;">
              <td style="border: 1px solid #000;" colspan="2">审核审批<br/>意　　见</td>
              <td style="border: 1px solid #000;text-align: left;padding-top: 10px;padding-left: 10px;" colspan="10">
                <div style="text-align: right;margin-top: 40px;margin-bottom: 10px;margin-right: 50px;">
                  <div> （盖章）</div>
                  <div style="margin-top: 5px;">年&nbsp;月&nbsp;日 </div>
                </div>
              </td>
            </tr>
          </table>
          <div style="text-align: right;width: 1000px;margin-bottom: 5px;">填报日期：{{info.year}}&nbsp;年&nbsp;{{info.month}}&nbsp;月&nbsp;{{info.day}}&nbsp;日</div>
          <div style="padding-left: 30px;text-align: left;">备注：根据最多跑一次要求，证件快递送达，请完整并准确填写通讯地址。 </div> 
       </div>
        <div v-if="flow==2" ref="print" id="pdfDom" style="width: 1080px;height:auto;text-align: center;font-size: 18px;line-height: 30px;" class="print-div">
          <label style="font-size: 36px;font-weight: bold;margin: 10px 0 50px 0;display: inline-block;">健康申报表</label>
          <div style="text-align: right;width: 1000px;margin: 10px auto;">填报时间：{{info.year}}&nbsp;&nbsp;&nbsp;年&nbsp;&nbsp;&nbsp;{{info.month}}&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;&nbsp;{{info.day}}&nbsp;&nbsp;&nbsp;日</div>
          <table style="margin: 0 auto;width: 1000px;border: 3px solid #000;border-collapse: collapse;font-size: 20px;">
            <tr style="height: 140px;">
              <td style="border: 1px solid #000;width:200px;">姓名</td>
              <td style="border: 1px solid #000;width:200px;">{{info.name}}</td>
              <td style="border: 1px solid #000;width:200px;">身份证号</td>
              <td style="border: 1px solid #000;width:400px;">{{info.cid}}</td>
            </tr>
            <tr style="height: 140px;">
              <td style="border: 1px solid #000;">常住地地址</td> 
              <td style="border: 1px solid #000;" colspan="3">{{info.address}}</td>
            </tr>
            <tr style="height: 140px;">
              <td style="border: 1px solid #000;">本人健康状况</td>
              <td style="border: 1px solid #000;text-align: left;padding: 10px;" colspan="3">
                <div>1.健康（{{info.is_health==1?'✔':' '}}）；</div>
                <div>2.有症状：发热（{{"1"|isTest(symptom)}}）、咳嗽（{{"2"|isTest(symptom)}}）、胸闷（{{"3"|isTest(symptom)}}）、乏力（{{"4"|isTest(symptom)}}）、其他（{{"5"|isTest(symptom)}}）</div>
                <div>3.健康码：绿码（{{info.health_code==1?'✔':' '}}）、黄码（{{info.health_code==2?'✔':' '}}）、红码（{{info.health_code==3?'✔':' '}}）</div>
              </td>
            </tr>
            <tr style="height: 140px;">
              <td style="border: 1px solid #000;">共同生活人员健康状况</td>
              <td style="border: 1px solid #000;text-align: left;padding: 10px;" colspan="3">
                <div>1.健康（{{info.living_together_health==1?'✔':' '}}）；</div>
                <div>2.有症状：发热（{{"1"|isTest(living_together_symptom)}}）、咳嗽（{{"2"|isTest(living_together_symptom)}}）、
                  胸闷（{{"3"|isTest(living_together_symptom)}}）、乏力（{{"4"|isTest(living_together_symptom)}}）、其他（{{"5"|isTest(living_together_symptom)}}）</div>
              </td>
            </tr>
            <tr style="height: 140px;">
              <td style="border: 1px solid #000;">本人旅行史</td>
              <td style="border: 1px solid #000;text-align: left;padding: 10px;" colspan="3">
                <div>近21天内有无离开常住地？</div>
                <div>1.无（{{info.is_travel==0?'✔':' '}}）；</div>
                <div>2.有（{{info.is_travel==1?'✔':' '}}），</div>
                <div>&nbsp;&nbsp;&nbsp;到过地方（注明：{{info.travel_place}}）</div>
                <div>3.现居住在：常住地（{{info.is_stay_regularly==1?'✔':' '}}）、其他地方（注明：{{info.other_place}}）</div>
              </td>
            </tr>
            <tr style="height: 140px;">
              <td style="border: 1px solid #000;">常住地（范围到乡镇街道）疫情情况</td>
              <td style="border: 1px solid #000;text-align: left;padding: 10px;" colspan="3">
                <div>近21天内有无发生疫情？</div>
                <div>1.无（{{info.is_stay_regularly_safe==0?'✔':' '}}）；</div>
                <div>2.有（{{info.is_stay_regularly_safe==1?'✔':' '}}），具体情况</div>
                <div>&nbsp;&nbsp;&nbsp;本土病例（{{"1"|isTest(case_type)}}）、
                  境外输入病例（{{"2"|isTest(case_type)}}）、
                  无症状感染病例（{{"3"|isTest(case_type)}}）</div>
              </td>
            </tr>
            <tr style="height: 140px;">
              <td style="border: 1px solid #000;">人员接触情况</td>
              <td style="border: 1px solid #000;text-align: left;padding: 10px;" colspan="3">
                <div>近21天内有无接触涉疫情人员？</div>
                <div>1.无（{{info.is_contact_sick==0?'✔':' '}}）；</div>
                <div>2.有（{{info.is_contact_sick==1?'✔':' '}}），具体情况</div>
                <div>&nbsp;&nbsp;&nbsp;确诊病人（{{"1"|isTest(contact_sick_type)}}）、
                  疑似病人（{{"2"|isTest(contact_sick_type)}}）、
                  无症状感染者（{{"3"|isTest(contact_sick_type)}}）、
                  与上述3类人员有接触者（{{"4"|isTest(contact_sick_type)}}）</div>
              </td>
            </tr>
            <tr style="height: 140px;">
              <td style="border: 1px solid #000;">本人承诺</td>
              <td style="border: 1px solid #000;text-align: left;padding: 20px 10px;" colspan="3">
                <div>本人对以上所填内容的真实性和完整性负责，资源接受监督和核查。</div>
                <div style="text-align: right;padding-right: 200px;margin-top: 20px;">
                签名：<img class="signature" v-if="info.electronic_signature" :src="info.electronic_signature" />
                </div>
              </td>
            </tr>
            <tr style="height: 140px;">
              <td style="border: 1px solid #000;">备注</td>
              <td style="border: 1px solid #000;text-align: left;padding: 20px 10px;" colspan="3">
              </td>
            </tr>
          </table>
        </div>

      </div>
      <div data-v-fd68d6dc="" class="ht30"></div>
    </div>
    <Bottom />
  </div>
</template>

<script>
import Top from '../top'
import Banner from '../banner'
import Bottom from '../bottom'
import BannerTitle from './signTitle'
export default {
  name: 'detail',

  components: {
    Top,
    Banner,
    Bottom,
    BannerTitle
  },

  data () {
    return {
      htmlTitle: 'test',
      gender_list: {1: '男', 0: '女'},
      flow: 1,
      info: {
        specialWorkerTraining: {
          type: ''
        }
      },
      edu_options: {}
    }
  },

  computed: {
    symptom: function () {
      var t_d = this.info.symptom.split(',')
      return t_d
    },
    living_together_symptom: function () {
      var t_d = this.info.living_together_symptom.split(',')
      return t_d
    },
    case_type: function () {
      var t_d = this.info.case_type.split(',')
      return t_d
    },
    contact_sick_type: function () {
      var t_d = this.info.contact_sick_type.split(',')
      return t_d
    },
  },

  filters: {
    isTest: function (symptom_id, symptom) {
      var a = symptom.indexOf(symptom_id)
      if (a != -1) {
        return '✔'
      } else {
        return ' '
      }
    }
  },

  created () {
    this.info.id = this.$route.query.id
    this.getData()
    this.getCommon()
  },

  mounted () {

  },

  methods: {
    dowmLoadPdf: function () {
      this.getPdf()
    },
    print: function () {
      this.$print(this.$refs.print)
    },
    getData: function () {
      this.$request.get('training-skill/get-special-worker-enroll-record-by-id', this.info, response => {
        if (response.status == 200 && response.data.code == 200) {
          this.info = response.data.data
          if (this.info.electronic_signature) { this.info.electronic_signature = this.$request.file_server + this.info.electronic_signature }
          // this.flow = 1;
        } else {
          alert('无数据')
        }
      }, error => {
        console.log(error)
      })
    },
    getCommon(){
      this.$request.get('training-skill/skill-appraisal-options', {}, response => {
        if (response.status == 200 && response.data.code == 200) {
          const data = response.data.data
          this.edu_options = data.edu_level
          this.gender_list = data.promotion_gender
 
        } else {
          alert('无数据')
        }
      }, error => {
        console.log(error)
      })
    }
  }
}
</script>

<style scoped>
  .pproject-wrap .detail{padding: 50px 55px 40px;}
  .hr-div{width: 100%;height: 1px;border-top: 1px solid rgb(233,233,233);margin: 30px 0}
  .sign-row{min-height: 40px;line-height: 26px;margin-top: 14px;}
  .sign-row26{min-height: 26px;}
  .sign-row .label{width: 340px;display: inline-block;line-height: 35px;text-align: right;font-size: 16px;color: rgb(51,51,51);}
  .sign-row .content{width: 780px;display: inline-block;margin-left: 40px;}
  .sign-row .content-select{width: 345px;height: 34px;line-height: 34px;border: 1px solid rgb(212,218,221);background: rgb(243,243,243);}
  .sign-row .content-select3{width:120px;margin-right: 15px;}
  .sign-row .content-select2{width:61px;margin-right: 10px;}
  .sign-row .content-select1{width:50px;margin-right: 5px;}
  .sign-row .content-item{vertical-align: middle;color: rgb(119,119,119);}
  .sign-row .content-item .insert-label{width:26px;}
  .sign-row input[type=checkbox]{vertical-align: top;width:18px;height:18px;margin-right: 12px;margin-top: 5px;}
  .sign-row input[type=radio]{vertical-align: top;width:18px;height:18px;margin-right: 12px;margin-top: 5px;}
  .sign-row .content-item label{vertical-align: top;display: inline-block;width:900px;}
  .sign-row .content-item input[type=file]{display: none;}
  .sign-row .content-item .changeButton{vertical-align: middle;display: inline-block;width: 48px;height: 34px;line-height: 34px;text-align: center;border: 1px solid #d4dadd;background: #f3f3f3;}
  .sign-row .sub-button{display: inline-block;margin: 0 auto;width: 180px;height: 46px;line-height: 46px;text-align: center;background: #147ad8;color: #fff;border-radius: 5px;}
  .center-row{text-align: center;}
  .step{width: 600px;margin: 0 auto;}
  .step-box{display: inline-block;width:100px}
  .step-box a{margin: 0 auto;font-size:24px;display: block;width: 54px;height: 54px;line-height: 56px;text-align: center;border: 1px solid rgb(153,153,153);color: rgb(153,153,153);border-radius: 50%;}
  .step-box a.active{border: 1px solid rgb(21,121,215);color: #fff;background:rgb(21,121,215); }
  .step-box span{display: inline-block;width: 100%;text-align: center;margin-top: 18px;}
  .step-line{display: inline-block;width: 121px;height: 2px;border-top: 2px solid rgb(168,168,168);vertical-align: top;margin-top: 26px;}
  .label-top{vertical-align: top;}
  .check-span{display: block;line-height: 35px;}
  .check-span input[type=checkbox]{margin-top: 8px;margin-left: 10px;}
  .check-span input[type=radio]{margin-top: 8px;margin-left: 10px;}
  .check-span .check-text{width:140px;margin-left: 10px;}
  table{text-align: center;}
  .print-div{padding-bottom: 30px;margin: 0 auto;}
  .signature{width: 100px;}
</style>


// WEBPACK FOOTER //
// src/components/train/project/print.vue